$(function() {
  /* hide all tooltips */
  $('.filter-div .tooltip-filter').hide();
  $('.shipping-category .tooltip-filter').hide();
  $('.checkout-controls .tooltip-filter').hide();

  /* bind custom listeners: when you want to show a tooltip, drop this listener */
  $('.shipping-category .tooltip-filter').on('shipping-tooltip', show_tooltip);
  $('.checkout-controls .tooltip-filter').on('terms-tooltip', show_tooltip);

  /* bind on click events to dismiss tooltips */
  $('.tooltip-button button').on('click', function() {
     $(this).closest('.tooltip-filter').hide();
     return false;
  });

  /* specific code for collection tooltip
   * which should really move to its own file */
  if(!readCookie('tooltip')){
    $('.filter-div .tooltip-filter').show();
  }

  $('.filter-div .tooltip-button button').click(function(){
    createCookie('tooltip','yes',300);
  });

});

function show_tooltip(e, valid) {
  if (!valid) {
    $(this).show();
  }
}

function createCookie(name,value,days) {
  if (days) {
    var date = new Date();
    date.setTime(date.getTime()+(days*24*60*60*1000));
    var expires = "; expires="+date.toGMTString();
  }
  else var expires = "";
  document.cookie = name+"="+value+expires+"; path=/";
}

function readCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++) {
    var c = ca[i];
    while (c.charAt(0)==' ') c = c.substring(1,c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
  }
  return null;
}

function eraseCookie(name) {
  createCookie(name,"",-1);
}

